import styled from "@emotion/styled/macro";
import { PrimaryButton, SecondaryButton } from '../../../../common/components/buttons/NewButtons.styles';
import { colors, views } from "../../../../common/styles/theme.styles";

export const PopoverContainer = styled.div`
  width: 248px;
  background: ${colors.darkGray1};
  border-radius: 10px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04), 0px 1px 4px 0px rgba(0, 0, 0, 0.08);
  color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0px 0px 16px;

  ${views.tablet} {
    width: 100%;
    padding: 16px 20px 24px;
    gap: 16px;
  }
`;

export const ConnectionInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 12px 16px 0px;
`;

export const EntityName = styled.span`
  font-family: Circular;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.265;
  color: #ffffff;
`;

export const ArrowIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 20px;
    height: 20px;
    stroke: #ffffff;
    stroke-width: 1.25px;
  }
`;

export const OwnershipSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 6px 12px;
  margin: 0px 16px;
  background: #1A1B1D;
  border: 1px solid #ACB1BB;
  border-radius: 10px;
  height: 60px;

  ${views.tablet} {
    margin: 0px 0px;
    padding: 12px 16px;
    height: auto;
    min-height: 80px;
  }
`;

export const OwnershipLabel = styled.label`
  font-family: Circular;
  font-weight: 450;
  font-size: 12px;
  line-height: 1.265;
  color: #ACB1BB;
`;

export const OwnershipInputWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const OwnershipInput = styled.input`
  background: transparent;
  border: none;
  color: #ffffff;
  font-family: Circular;
  font-weight: 450;
  font-size: 16px;
  line-height: 1.265;
  outline: none;
  width: 100%;
  
  &::placeholder {
    color: #666;
  }

  &:disabled {
    opacity: 0.6;
  }

  ${views.tablet} {
    font-size: 18px;
    min-height: 44px;
    padding: 8px 0;
  }
`;



export const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  padding: 4px 16px 0px;

  ${views.tablet} {
    gap: 12px;
    padding: 8px 0px 0px;
  }
`;

export const DeleteButton = styled(SecondaryButton)`
  flex: 1;
  height: 36px;
  background: #1A1B1D;
  border: 1px solid #585D66;
  border-radius: 10px;
  color: #ffffff;
  font-family: Circular;
  font-weight: 450;
  font-size: 14px;
  line-height: 1.265;
  
  &:hover {
    background: #25272C;
  }

  &:disabled {
    opacity: 0.6;
  }

  ${views.tablet} {
    height: 48px;
    font-size: 16px;
    min-height: 44px;
  }
`;

export const SaveButton = styled(PrimaryButton)`
  flex: 1;
  height: 36px;
  background: #ffffff;
  border: none;
  border-radius: 10px;
  color: ${colors.darkGray1};
  font-family: Circular;
  font-weight: 450;
  font-size: 14px;
  line-height: 1.265;
  
  &:hover {
    background: #f0f0f0;
  }

  &:disabled {
    opacity: 0.6;
  }

  ${views.tablet} {
    height: 48px;
    font-size: 16px;
    min-height: 44px;
  }
`; 